import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Grid } from '@mui/material'
import PostLogin from '../../../layout/post-login'
import { ROUTES } from '../../../constants'
import { useMuiSnackbar } from '../../../hooks'
import LocationService from '../../../services/location.service'
import { Title, TableWrapper } from '../../../components'
import { ListItemTextStyled } from './style'

const LocationViewPage = () => {
  const [locationData, setLocationData] = useState({})
  const [gridLoader, setGridLoader] = useState(true)
  const { id } = useParams()
  const { SnackbarError } = useMuiSnackbar()

  const tableData = {
    title: 'Location view',
    rows: locationData
  }

  useEffect(() => {
    LocationService.getOneLocation(id)
      .then((resp) => {
        setLocationData(resp?.data)
      })
      .catch((error) => {
        SnackbarError(error)
      })
      .finally(() => {
        setGridLoader(false)
      })
  }, [])

  return (
    <PostLogin heading='Location View' fixed>
      <Title
        primaryButton={{
          to: ROUTES.ROUTE_LOCATION_LIST,
          title: 'back',
          size: 'small'
        }}
      />

      <TableWrapper data={tableData} loader={gridLoader}>
        <Grid container spacing={2}>
          <Grid item md={4}>
            <ListItemTextStyled
              primary='Name'
              secondary={locationData?.name}
            />
          </Grid>
          <Grid item md={4}>
            <ListItemTextStyled
              primary='description'
              secondary={locationData?.description}
            />
          </Grid>
        </Grid>
      </TableWrapper>

    </PostLogin>
  )
}

export default LocationViewPage
